import React from 'react';
import styled, { css } from 'styled-components';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { push } from 'connected-react-router';
import { rgba } from 'polished';
import { isCabinet } from '@lib/is-cabinet';
import { Divider } from '../../../ui/atoms';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';

const enchance = compose(
  connect(),
  withHandlers({
    onUserClick: ({ setCurrentTeam }) => (onClose) => {
      setCurrentTeam(null);
      onClose();
    },
    onTeamClick: ({ setCurrentTeam }) => (id, onClose) => {
      setCurrentTeam(id);
      onClose();
    },
    onLogoutClick: ({ onLogout }) => (onClose) => {
      onClose();
      onLogout();
    },
    onAddTeam: ({ onClose, dispatch }) => () => {
      const isTariffManagment = window.location.pathname.indexOf('tariff-managment') !== -1;

      if (isCabinet && !isTariffManagment) {
        dispatch(push('/tariff-managment/?tariff=4'));
      } else {
        window.location = `/${window._lang}/cabinet/tariff-managment/?tariff=4`;
      }

      onClose();
    },
  })
);

const ProfileView = ({
  username,
  avatar,
  teams,
  onClose,
  onUserClick,
  onTeamClick,
  currentTeam,
  onLogout,
  onAddTeam,
}) => (
  <Container>
    <Item active={currentTeam === null} onClick={() => onUserClick(onClose)}>
      <Text>{username}</Text>
      <Icon src={avatar} />
    </Item>
    <Divider padding={16} />
    {teams.length !== 0 && (
      <React.Fragment>
        <Teams teams={teams} onClose={onClose} currentTeam={currentTeam} onTeamClick={onTeamClick} />
        <Divider padding={16} />
      </React.Fragment>
    )}
    <AddGroup onClick={onAddTeam}>
      <Text>{i18next.t('cabinet.widget.add_team')}</Text>
      <Icon>+</Icon>
    </AddGroup>
    <Spacer />
    <Logout onClick={() => onLogout(onClose)}>{i18next.t('cabinet.widget.logout')}</Logout>
  </Container>
);

export const Profile = enchance(ProfileView);

const Teams = ({ currentTeam, teams, onTeamClick, onClose }) => (
  <React.Fragment>
    {teams &&
      teams.map(({ id, caption, avatar }) => (
        <Item key={id} to="/" active={currentTeam === id} onClick={() => onTeamClick(id, onClose)}>
          <Text>{caption || 'Id команды: ' + id}</Text>
          <Icon src={avatar} />
        </Item>
      ))}
  </React.Fragment>
);

const Container = styled.div`
  font-size: 14px;
  font-weight: 500;
  background-color: ${Colors.white};
  border-radius: 10px;
  padding-bottom: 13px;
  box-shadow: 0 4px 10px 0 ${rgba(Colors.black, 0.15)};
  overflow: hidden;
  color: ${Colors.coal};
`;

const item = css`
  ${Mixins.transition('background-color')};
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  border: none;
  padding: 8px 8px 8px 18px;
  width: 100%;
  background-color: ${Colors.white};
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;

  &:hover {
    background-color: ${Colors.ivory};
  }

  ${(p) =>
    p.active &&
    css`
      &:before {
        content: '';
        position: absolute;
        left: 6px;
        transform: translateY(-50%);
        top: 50%;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: ${Colors.planoplan_blue};
      }
    `}
`;
const Item = styled.button`
  ${item}
`;

const Text = styled.div`
  padding-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Icon = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 4px;
  font-size: 18px;
  background-image: ${(p) => (p.src ? `url(${p.src})` : 'none')};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const Spacer = styled.div`
  width: 100%;
  height: 38px;
`;

const AddGroup = styled.button`
  ${item};
  text-decoration: none;
  color: ${Colors.coal};
`;

const Logout = styled(Item)`
  height: 38px;
`;
